import React, { PropsWithChildren } from "react";

import { clsx } from "clsx";

type Props = {
  title?: string;
  fullHeight?: boolean;
  grid?: boolean;
  flex?: boolean;
  gridLayout?: boolean;
  gridCols?: string;
  resFlex?: boolean;
  size?: string;
  col?: string;
  last?: boolean;
  className?: string;
  centered?: boolean;
  relative?: boolean;
  keyline?: boolean;
  padding?: string;
  mx?: string;
  my?: string;
  mt?: string;
  mb?: string;
  px?: string;
  py?: string;
  pl?: string;
  pr?: string;
  pt?: string;
  pb?: string;
};

const Layout = ({
  children,
  size,
  gridLayout,
  gridCols,
  grid,
  flex,
  resFlex,
  className,
  fullHeight,
  centered,
  keyline,
  mx,
  my,
  mt,
  mb,
  py,
  px,
  pl,
  pr,
  pt,
  pb,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={clsx({
        "layout-segment": true,
        "grid-layout": gridLayout,
        "grid-row": grid,
        "grid-flex": flex,
        "grid-row-flex": resFlex,
        "full-height": fullHeight,
        ac: centered,
        keyline,
        [`${className ? className : ""}`]: className,
        [`${size ? "size-" + size : ""}`]: size,
        [`${gridCols ? "cols-" + gridCols : ""}`]: gridCols,
        [`${mx ? "mx-" + mx : ""}`]: mx,
        [`${my ? "my-" + my : ""}`]: my,
        [`${mt ? "mt-" + mt : ""}`]: mt,
        [`${mb ? "mb-" + mb : ""}`]: mb,
        [`${px ? "px-" + px : ""}`]: px,
        [`${py ? "py-" + py : ""}`]: py,
        [`${pl ? "pl-" + pl : ""}`]: pl,
        [`${pr ? "pr-" + pr : ""}`]: pr,
        [`${pt ? "pt-" + pt : ""}`]: pt,
        [`${pb ? "pb-" + pb : ""}`]: pb,
      })}
    >
      {children}
    </div>
  );
};

Layout.Segment = ({
  col,
  last,
  children,
  padding,
  className,
  relative,
  py,
  px,
  pl,
  pr,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={clsx({
        "grid-item": true,
        "grid-last": last,
        "grid-relative": relative,
        [`${col ? "grid-" + col : ""}`]: col,
        [`${className ? className : ""}`]: className,
        [`${padding ? "p-" + padding : ""}`]: padding,
        [`${px ? "px-" + px : ""}`]: px,
        [`${py ? "py-" + py : ""}`]: py,
        [`${pl ? "pl-" + pl : ""}`]: pl,
        [`${pr ? "pr-" + pr : ""}`]: pr,
      })}
    >
      {children}
    </div>
  );
};

export default Layout;
